import { forwardRef, createElement } from 'react';
import { lightColorwayClassName, Colorway as Colorway$2 } from '@uds/theme-utils';
export { Colorway as Colorways } from '@uds/theme-utils';
import { cx } from 'linaria';
import './colorway.stylesheet_1f7fd3v.css';

let AdditionalColorways;
(function (AdditionalColorways) {
  AdditionalColorways["HEADER"] = "HEADER";
})(AdditionalColorways || (AdditionalColorways = {}));

const light = "l1vjk6zv";
const neutral = "njcia3u";
const dark = "d1awy65t";
const primary = "p2suzm8";
const primaryGradient = primary;
const highlight = "hynn9p3";
const header = "h2w9vbx";
const defaultColorways = {
  LIGHT: cx(light, lightColorwayClassName),
  NEUTRAL: neutral,
  DARK: dark,
  PRIMARY: primary,
  PRIMARY_GRADIENT: primaryGradient,
  HIGHLIGHT: highlight
};
const additionalColorways = {
  HEADER: header
};
const colorways = {
  ...defaultColorways,
  ...additionalColorways
};
const getClassNames = _ref => {
  let {
    colorway,
    className
  } = _ref;
  return cx(colorway != null && colorways[colorway], className);
};

const Colorway = (_ref, ref) => {
  let {
    colorway = Colorway$2.LIGHT,
    component = 'div',
    className,
    children,
    ...props
  } = _ref;
  const classNames = getClassNames({
    colorway,
    className
  });
  return /*#__PURE__*/createElement(component, {
    className: classNames,
    ...props,
    ref
  }, children);
};
Colorway.displayName = 'Colorway';
var Colorway$1 = /*#__PURE__*/forwardRef(Colorway);

export { AdditionalColorways, Colorway$1 as default };
